(ns teamoesterreich.actions.auth
  (:require
    [shadow.cljs.modern :refer (js-await)]
    [teamoesterreich.config :as config]
    [teamoesterreich.firebase.auth :as auth]
    [teamoesterreich.firebase.provider :as fs-provider]
    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.backend :as backend]
    [teamoesterreich.util.log :as log]))


(defn >do-login [oidc-token]
  (js-await [firebase-token (or (when-let [auth (js/firebase.auth)]
                                  (when-let [user (.-currentUser auth)]
                                    (.getIdToken user)))
                                (js/Promise. (fn [resolve] (resolve nil))))]
    (js-await [response (js/fetch (str backend/BASE_URL "/login-oauth")
                                  #js{:method  "POST"
                                      :headers #js{:Content-Type "application/json"}
                                      :body    (js/JSON.stringify #js{:oidc-token     oidc-token
                                                                      :firebase-token firebase-token})})]
      (js-await [^js body (.json response)]
        (auth/login-fb (.-token body))))

    (catch e (js/console.error e ">do-login failed") nil)))

(defn open-login []
  (.signinRedirect config/user-manager))

(defn handle-oauth-url []
  (condp = js/location.pathname
    "/oauth/post-login"
    (js-await [user (.signinCallback config/user-manager js/location.href)]
      (if user
        (js-await [^js login-result (>do-login (.-access_token user))]
          (if login-result
            (js-await [has-required? (fs-provider/promise-has-required-fields? (.. login-result -user -uid))]
              (if has-required?
                (do
                  (js/history.replaceState nil nil "/")
                  (swap! store/app-state assoc :site :landing))

                (do
                  (js/history.replaceState nil nil "/onboard-required")
                  (swap! store/app-state assoc :site :onboard-required))
                ))

            (do
              (js/history.replaceState nil nil "/")
              (swap! store/app-state assoc :site :landing :login-error true)
              )))

        (do
          (js/history.replaceState nil nil "/")
          (swap! store/app-state assoc :site :landing))))

         "/oauth/post-login/lebensretter"
         (js-await [user (.signinCallback config/user-manager js/location.href)]
                   (if user
                     (js-await [_ (>do-login (.-access_token user))]
                               (log/out "login-success")
                               (js-await [_ (fs-provider/load-user (fs-provider/get-uid))]
                                         (js-await [_ (fs-provider/load-documents (fs-provider/get-uid))]
                                                   (store/update-loading :auth)
                                                   nil)))

                     (do
                       (log/out "login-failed 1")
                       (js/Promise. (fn [resolve _] (resolve js/undefined))))))

         "/oauth/post-login/event"
         (js-await [user (.signinCallback config/user-manager js/location.href)]
                   (if user
                     (js-await [_ (>do-login (.-access_token user))]
                               (log/out "login-success")
                               (js-await [_ (fs-provider/load-user (fs-provider/get-uid))]
                                         (js-await [_ (fs-provider/load-documents (fs-provider/get-uid))]
                                                   (store/update-loading :auth)
                                                   nil)))

                     (do
                       (log/out "login-failed 1")
                       (js/Promise. (fn [resolve _] (resolve js/undefined))))))

    "/oauth/post-logout"
    (js-await [_ (.signoutCallback config/user-manager js/location.href)]
      (js-await [_ (auth/logout)]
        (js/history.replaceState nil nil "/")
        (swap! store/app-state assoc :site :landing)))

    "/oauth/frontchannel-logout"
    (js-await [_ (auth/logout)]
      (.removeUser config/user-manager)
      (js/history.replaceState nil nil "/")
      (swap! store/app-state assoc :site :landing))

    (js/Promise. (fn [resolve _] (resolve js/undefined))))
  )


(defn logout []
  (.signoutRedirect config/user-manager)
  )
